import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndoorWorldSeriesEliteRankingRoutingModule } from './indoor-world-series-elite-ranking-routing.module';
import { IndoorEliteBootstrapComponent } from './indoor-elite-bootstrap/indoor-elite-bootstrap.component';
import { FiltersEliteRankingComponent } from './filters-elite-ranking/filters-elite-ranking.component';
import { FiltersEliteInfoComponent } from './filters-elite-info/filters-elite-info.component';
import { EliteRankingListComponent } from './elite-ranking-list/elite-ranking-list.component';
import { EliteRankingComponent } from './elite-ranking/elite-ranking.component';
import { FiltersSeriesEliteRankingService } from './filters-series-elite-ranking.service';
import { FormsModule } from '@angular/forms';
import { ParseRankPipe } from './parse-rank.pipe';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from 'world-archery-lib';
import { HttpClientModule } from '@angular/common/http';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  bootstrap: [IndoorEliteBootstrapComponent],
  imports: [
    CommonModule,
    IndoorWorldSeriesEliteRankingRoutingModule,
    FormsModule,
    CoreModule,
    SharedModule,
    HttpClientModule,
    CommonPageComponentsModule
  ],
  declarations: [
    IndoorEliteBootstrapComponent,
    FiltersEliteRankingComponent,
    FiltersEliteInfoComponent,
    EliteRankingListComponent,
    EliteRankingComponent,
    ParseRankPipe
  ],
  providers: [ParseRankPipe, FiltersSeriesEliteRankingService]
})
export class IndoorWorldSeriesEliteRankingModule { }
